import React from 'react'
import { SelectPicker, Stack } from 'rsuite'

const AddedOnFIlter = ({ showboth, showLable = false, AddedOn, selectedDateRange, handleDatechange, selectedUpdatedDateRange, handleUpdatedDatechange }) => {
    return (
        <>
            <Stack spacing={5}>
                {(showboth == 'both' || showboth == 'added') &&
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {showLable && <label>Added On</label>}
                        <SelectPicker
                            data={AddedOn}
                            size="md"
                            appearance="default"
                            placeholder="Added On"
                            style={{ width: 145 }}
                            value={selectedDateRange}
                            onChange={handleDatechange}
                            container={() => document.getElementById('custom-container')}
                        />
                    </div>
                }
                {(showboth == 'both' || showboth == 'updated') &&
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {showLable && <label>Updated On</label>}
                        <SelectPicker
                            data={AddedOn}
                            size="md"
                            appearance="default"
                            placeholder="Updated On"
                            style={{ width: 145 }}
                            value={selectedUpdatedDateRange}
                            onChange={handleUpdatedDatechange}
                            container={() => document.getElementById('custom-container')}
                        />
                    </div>
                }
            </Stack>
        </>
    )
}

export default AddedOnFIlter